module.exports = __webpack_public_path__ + "img/niu16.ac2ea539.jpg";